export default class MapPlugin {
    static get toolbox() {
        return {
            title: 'Карта',
            icon: 'M'
        };
    }
    constructor({data, api, config}){
        this.api = api;
        this.from=null;
        this.to=null;
        this.data = data;
        this.config = config || {};
        this.wrapper = undefined;
    }

    render(){
        var app=this;
        app.wrapper=document.createElement("div");
        app.wrapper.classList.add("cdx-block");


        this.from=document.createElement('input');
        this.from.classList.add('cdx-input');
        this.from.classList.add('from');
        this.from.placeholder="Введите точный адрес отправления";
        this.from.value = this.data && this.data.from_title ? this.data.from_title : '';

       this.to=document.createElement("input");
        this.to.classList.add("cdx-input");
        this.to.placeholder="Введите точный адрес доставки";
        this.to.value = this.data && this.data.to_title ? this.data.to_title : '';
        this.to.classList.add('to');
        var button=document.createElement("button");
        button.classList.add("cdx-button");
        button.innerText="Загрузить координаты";

        button.onclick = function(){

            app.wrapper.classList.add('cdx-loader');
            var result={

            };
            const from_title = app.from.value;
            const to_title = app.to.value;
            result.from_title=from_title;
            result.to_title=to_title;
            let xhr = new XMLHttpRequest();
            xhr.open("POST", app.config.url);
            xhr.setRequestHeader("Accept", "application/json");
            xhr.setRequestHeader("Content-Type", "application/json");

            xhr.onreadystatechange = function () {
                if (xhr.readyState === 4) {

                    var json_answer=JSON.parse(xhr.responseText);
                    if(json_answer.to && json_answer.from){
                        result.to=json_answer.to;
                        result.from=json_answer.from;
                    }
                    //return myResolve(result);
                    app.wrapper.classList.remove('cdx-loader');
                    app.data=result;
                }};



            xhr.send(JSON.stringify(result));
        };



        app.wrapper.appendChild(this.from);
        app.wrapper.appendChild(this.to);
        app.wrapper.appendChild(button);
        return app.wrapper;
    }

    save(blockContent){


        var result=this.data;


        return result;







    }
    validate(savedData){

        if(!savedData.to){
            return false;
        }
        if(!savedData.from){
            return false;
        }




        return true;
    }
}